import request from '@/sheep/request';

const UserPublicApi = {
	// 获取用户公开信息（个人中心展示用）
	getUserPublicInfo: (userId: number) => {
		return request({
			url: '/wish/user/public-info',
			method: 'GET',
			params: { userId },
			custom: {
				showLoading: false,
			},
		});
	},

	// 获取用户发布的愿望列表
	getUserWishes: (params: { userId: number; page?: number; pageSize?: number }) => {
		return request({
			url: '/wish/wishes/user/page',
			method: 'GET',
			params,
			custom: {
				showLoading: false,
			},
		});
	},
};

export default UserPublicApi;
